/** Service keys used in transfer/sync routes and SEOConstant */
export type ServiceKey = "spotify" | "appleMusic" | "youtubeMusic" | "youtube" | "tidal";

export const BRANDS: Record<
    ServiceKey,
    { name: string; spanClass: string }
> = {
    spotify: { name: "Spotify", spanClass: "text-[#1DB954]" },
    appleMusic: { name: "Apple Music", spanClass: "text-[#FA233B]" },
    youtubeMusic: { name: "YouTube Music", spanClass: "text-red-600" },
    youtube: { name: "YouTube", spanClass: "text-[#FF0000]" },
    tidal: { name: "Tidal", spanClass: "text-black dark:text-white" },
};

export const PRODUCT_URLS: Record<ServiceKey, string> = {
    spotify: "https://spotify.com",
    appleMusic: "https://www.apple.com/apple-music/",
    youtubeMusic: "https://music.youtube.com",
    youtube: "https://www.youtube.com",
    tidal: "https://tidal.com",
};
